// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"e4c3c325","455":"cce74fb1","977":"27841dc4"}[chunkId] + ".chunk.js";
};